import React, { Component } from 'react';

class TextArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            is_valid: null,
            value: this.props.value || '',
        }
        this.update = this.update.bind(this);
    }

    update (value) {
        this.setState({
            value,
            is_valid: this.props.validation ? this.props.validation(value) : null,
        });
    }

    render () {
        const {
            name,
            label,
            submit,
            disabled = false,
            placeholder = '',
        } = this.props;
    
        const { is_valid, value } = this.state;
    
        return (
            <fieldset>
                <label>{label}</label>
                <textarea
                    rows={6}
                    disabled={disabled}
                    name={name}
                    autoComplete="off"
                    defaultValue={value}
                    placeholder={placeholder}
                    onKeyUp={(e) => {
                        this.update(e.target.value);
                    }}
                    onBlur={() => submit({
                        [name]: value,
                    })}
                />
                {is_valid === true && <div className="wf-valid"></div>}
                {is_valid === false && <div className="wf-invalid"></div>}
            </fieldset>
        )
    }
}

export default TextArea;
